import React from 'react'
import Constants from 'EurestoFonction/Constants'
import User from 'EurestoClass/User'
import Data from 'EurestoClass/Data'


import Recherche from 'EurestoComponents/Recherche'

import Search from '../Search'
import moment from 'moment'
import Tooltip from '@material-ui/core/Tooltip'
import Grid from '@material-ui/core/Grid/Grid'
import EmojiEuresto from 'Components/Emoji'

import h2p from 'html2plaintext'

moment.locale('fr')

class DatagridContact extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    const columns = [
      { Header: 'id', accessor: 'id', show: false },
      {
        Header: 'Type',
        width: 100,
        accessor: d => <Grid style={{ height: '100%' }} container alignItems={'center'}
          justify={'flex-start'}>{Object.keys(Constants.typeDocumentStock).find(key => Constants.typeDocumentStock[key] === d.type)}</Grid>,
        filterable: false,
        id: 'type',
      },
      {
        Header: <span>{EurestoI18n.t('commun:Référence')}</span>,
        accessor: d => <Grid style={{ height: '100%' }} container alignItems={'center'}
          justify={'flex-start'}>{d.reference}</Grid>,
        filterable: false,
        id: 'reference'
      },
      {
        Header: <span>{EurestoI18n.t('commun:Mouvement')}</span>,
        accessor: 'mouvement_id',
        filterable: false,
        width: 120,
        id: 'mouvement_id',
        Cell: row => {
          return <Grid style={{ height: '100%' }} container alignItems={'center'}
            justify={'flex-start'}>{
              (row.original.mouvement_id && Data.get(Constants.module.GESTION, Constants.donnee.type_mouvement, { id: row.original.mouvement_id }) || {}).abrege || ""
            }</Grid>
        }
      },
      {
        Header: <span>{EurestoI18n.t('commun:Fournisseur')}</span>,
        accessor: 'fournisseur_libelle',
        accessor: d => <Grid style={{ height: '100%' }} container alignItems={'center'}
          justify={'flex-start'}>{d.fournisseur_libelle}</Grid>,
        filterable: false,
        width: 150,
        id: 'fournisseur_libelle',
      },
      {
        Header: <span>{EurestoI18n.t('commun:Origine')}</span>,
        id: 'origine',
        accessor: 'fournisseur_libelle',
        filterable: false,
        width: 80,
        Cell: row => {
          return <Grid style={{ height: '100%' }} container alignItems={'center'}
            justify={'flex-start'}><span style={{
              color: EurestoColor(row.original.niveau === 0 && 'EurestoError'
                || (row.original.niveau === 1 || row.original.niveau === -1) && 'EurestoPrimary'
                || "EurestoSecondary")
            }}>{row.original.origine}</span></Grid>
        }
      },
      {
        Header: <span>{EurestoI18n.t('commun:Date Création')}</span>,
        accessor: 'date_creation',
        filterable: false,
        width: 120,
        id: 'date_creation',
        Cell: (row) => row.original.date_creation &&
          <Grid style={{ height: '100%' }} container alignItems={'center'}
            justify={'flex-start'}><span>{moment(row.original.date_creation, 'YYYY-MM-DD').format('DD/MM/YY HH:mm')}
              {!moment(row.original.date_modification).isSame(row.original.date_creation) && <br />}
              {!moment(row.original.date_modification).isSame(row.original.date_creation) && moment(row.original.date_modification, 'YYYY-MM-DD').format('DD/MM/YY HH:mm')}
            </span></Grid> || ''
      },

    ]
    return (
      <Recherche
        showSearch={this.props.showSearch}
        searchComponent={<Search defaultSearch={this.props.defaultSearch}
          search={this.props.search || 'document_' + (this.props.name || '') + User.Entite.get().id} />}
        view={'list'}
        data={this.props.data}
        type={this.props.type}
        style={this.props.style}
        onClick={this.props.onClick}
        columns={columns}
        search={this.props.search || 'document_' + (this.props.name || '') + User.Entite.get().id}
      />
    )
  }

}

export default DatagridContact



// WEBPACK FOOTER //
// ./app/App/Module/Stock/Component/Table/index.js